<template>
  <div class="about">
    <page-header :title="$t('coach.edit')" :desc="getName">
      <li class="breadcrumb-item"><router-link :to="{name:'coaches.index'}">{{ $tc('coach.name', 2) }}</router-link></li>
      <li class="breadcrumb-item">{{getName}}</li>
    </page-header>
    <page-content>
      <form @submit.prevent="onSubmit()">
        <ntm-block :title="$tc('image.name', 1)" :init-collapse="false">
          <template slot="options">
            <span>{{ $t('ratio') }}: <span class="font-weight-bold">1:1</span>, {{ $t('size') }}: <span class="font-weight-bold">500x500</span></span>
          </template>
          <ntm-crop entity-type="coach" :entity-uuid="$route.params.uuid" conversion="lg" collection="profile" :circle="true"></ntm-crop>
        </ntm-block>
        <ntm-block>
          <formly-form :form="form" :model="model" :fields="fields"></formly-form>
          <button class="btn btn-success push-15">{{$t('save')}}</button>
        </ntm-block>
      </form>
    </page-content>
  </div>
</template>

<script>
import fields from './formDefinition'
import CoachService from '@/services/coach.service'
import router from '@/router'

export default {
  // required properties, field, form, model
  data () {
    return {
      form: {},
      model: {},
      fields: fields,
      uploading: false
    }
  },
  beforeRouteEnter (to, from, next) {
    CoachService.show(to.params.uuid).then((response) => {
      next(vm => vm.setData(response.data))
    })
  },
  // beforeRouteUpdate (to, from, next) {
  //   CoachService.show(to.params.uuid).then((response) => {
  //     this.setData(response.data)
  //     store.commit('loaded')
  //   })
  // },
  methods: {
    setData (data) {
      this.model = data
    },
    onSubmit () {
      CoachService.update(this.model.uuid, this.model).then((response) => {
        setTimeout(() => {
          router.push({ name: 'coaches.index' })
        }, 300)
      }).catch((err) => {
        this.form.$errors = err.response.data.errors
      })
    }
  },
  computed: {
    getName () {
      if (this.model.middleName) {
        return this.model.lastName + ' ' + this.model.middleName + ' ' + this.model.firstName
      }
      return this.model.lastName + ' ' + this.model.firstName
    }
  }
}
</script>
